// extracted by mini-css-extract-plugin
export default {"buttonClass":"Approval_buttonClass__XZcWF","buttonClass--matches":"Approval_buttonClass--matches__hoUvN","boxButtonStyle":"Approval_boxButtonStyle__-1LB+"};